import { useState } from "react";
import { FilterRowMobile } from "./FilterRowMobile/FilterRowMobile";
import { FilterModal } from "./FilterModal/FilterModal";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { Filter, FilterValue } from "../types/filter";
import { TrackingProps } from "../types/component";

interface FilterPanelMobileProps {
  useFiltersFactory: (
    filterValues: FilterValue[],
    setFilterValues: (values: FilterValue[]) => void
  ) => Filter[];
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  feature: string;
}

// Main component to view filters.
export const FilterPanelMobile = ({
  useFiltersFactory,
  filterValues,
  setFilterValues,
  feature,
}: FilterPanelMobileProps) => {
  const [filterModalIsOpen, setFilterModalIsOpen] = useState(false);
  const [scrollTo, setScrollTo] = useState("");
  const filters = useFiltersFactory(filterValues, setFilterValues);
  const tracking: TrackingProps = { feature, mode: "mobile" };

  const onTriggerFilter = (filterId: string) => {
    setFilterModalIsOpen(true);
    setScrollTo(filterId);
  };
  const setFilterValuesWithTracking = (values: FilterValue[]) => {
    setFilterValues(values);
    trackerHelper.filter.trackFilterValues(tracking.feature, values);
  };

  return (
    <>
      <FilterRowMobile
        filters={filters}
        filterValues={filterValues}
        onTriggerFilter={onTriggerFilter}
        setFilterValues={setFilterValuesWithTracking}
        tracking={tracking}
      />
      <FilterModal
        visible={filterModalIsOpen}
        scrollTo={scrollTo}
        useFiltersFactory={useFiltersFactory}
        filterValues={filterValues}
        setFilterValues={setFilterValuesWithTracking}
        onClose={() => setFilterModalIsOpen(false)}
        tracking={tracking}
      />
    </>
  );
};
